export enum OrderXBZLogisticStatus {
  PEDIDO_CANCELADO = 'PEDIDO CANCELADO',
  PEDIDO_WEB_CANCELADO = 'PEDIDO/WEB CANCELADO',
  RETIRADO_ENVIADO_FINALIZADO = 'RETIRADO/ENVIADO/FINALIZADO',
  AGUARDANDO_APROVACAO_VENDAS = 'AGUARDANDO APROVAÇÃO DO SETOR DE VENDAS',
  AGUARDANDO_PAGAMENTO_SEPARACAO = 'AGUARDANDO PAGAMENTO PARA INICIAR A SEPARAÇÃO',
  PEDIDO_EMITIDO = 'PEDIDO EMITIDO',
  EM_PROCESSO_SEPARACAO = 'EM PROCESSO DE SEPARAÇÃO',
  PRONTO_AGUARDANDO_PAGAMENTO_RETIRADA = 'PRONTO E AGUARDANDO PAGAMENTO PARA LIBERAR RETIRADA',
  PRONTO_DISPONIVEL_RETIRADA = 'PRONTO E DISPONÍVEL PARA RETIRADA',
  PRONTO_DISPONIVEL_RETIRADA_SHOWROOM = 'PRONTO E DISPONÍVEL PARA RETIRADA NO SHOWROOM',
  PRONTO_CAMINHO_EXPEDICAO = 'PRONTO A CAMINHO DA EXPEDIÇÃO',
  PREPARANDO_PEDIDOS_GRAVACAO = 'PREPARANDO PEDIDOS PARA GRAVAÇÃO [Nome]',
  AGUARDANDO_PAGAMENTO_SAIDA = 'AGUARDANDO PAGAMENTO PARA PREPARAR SAÍDA',
  PRONTO_AGUARDANDO_OUTRO_PEDIDO_COLETA = 'PRONTO E AGUARDANDO OUTRO PEDIDO DA COLETA [Número]',
  PREPARANDO_PEDIDOS_TRANSPORTADORA = 'PREPARANDO PEDIDOS PARA TRANSPORTADORA [Número]',
  AGUARDANDO_TRANSPORTADORA = 'AGUARDANDO TRANSPORTADORA',
}

export type OrderXBZ = {
  id: number;
  numero: string;
  ordemDeCompra: string;
  emissaoClienteCodigo: string;
  emissaoClienteCnpj: string;
  emissaoClienteRazaoSocial: string;
  dataEmissao: string;
  pagamentoTipoId: number;
  pagamentoTipoNome: string;
  entregaTipoId: number;
  entregaTipoNome: string;
  entregaTransportadoraGravacaoId: number;
  entregaTransportadoraGravacaoNome: string;
  entregaQtdVolumes: number;
  produtoId: number;
  produtoCodigoXbz: string;
  produtoCodigoComposto: string;
  produtoCodigoAmigavel: string;
  produtoNome: string;
  quantidade: number;
  produtoPrecoUnitario: number;
  produtoValorImpostosTaxasUnitario: number;
  produtoValorTotal: number;
  pedidoValorImpostosTaxas: number;
  pedidoValorProdutos: number;
  pedidoValorTotal: number;
  statusLogistico: string;
  retiradaDetalhes: string;
  iniciaSeparacaoMediantePagamento: boolean;
  detalhes: string;
  ipOrigem: string;
  mensagensDiversasSistema: string;
  internalCompany?: number;
  availableQuantity?: number;
};
